import { ContextMenu2 } from "@blueprintjs/popover2";
import classNames from "classnames";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Tag } from "../../../components";
import { DeleteTagModal } from "../../../components/DeleteTagModal/delete-tag-modal";
import { TagCreator } from "../../../components/TagCreator/tag-creator";
import { PlayPropertyContextMenu } from "../../../components/play-property-context-menu/play-property-context-menu";
import { setPlayFilter } from "../../../redux/slices";
import { Tag as TTag, useDeleteTagMutation } from "../../../redux/slices/tag-api";
import styles from "./tag.tab.module.scss";

interface TagsItemProps {
  tag: TTag;
}

export const TagItem = ({ tag }: TagsItemProps) => {
  const [editingTag, setEditingTag] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteTag] = useDeleteTagMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteTag = (e: any) => {
    e.stopPropagation();
    setShowDeleteModal(false);
    deleteTag({ id: tag.tag_id });
  };

  const handleEditClick = () => {
    setEditingTag(true);
  };

  const handleNavigateToTagPlays = () => {
    dispatch(
      setPlayFilter({
        selectedTag: { id: tag.tag_id, label: tag.name },
        selectedPlayNameFilter: undefined,
        selectedSeason: undefined,
        selectedSeries: undefined,
        selectedTeam: undefined,
      })
    );
    navigate({ pathname: "/home/draw" });
  };

  return (
    <ContextMenu2
      key={tag.id}
      content={<PlayPropertyContextMenu playProperty="Tag" onDelete={handleDeleteClick} onEdit={handleEditClick} />}
    >
      <div className={styles.tagItem}>
        <div className={styles.tagDisplayContainer}>
          <Tag tag={tag} />
        </div>
        <div className={styles.tagInfoEditContainer}>
          <div className={classNames([styles.tagsNumber, styles.playsNumber])} onClick={handleNavigateToTagPlays}>
            {tag.noOfPlays}
          </div>
          <div className={classNames([styles.tagsNumber, styles.playbooksNumber])}>{tag.noOfPlayBooks}</div>
        </div>
      </div>
      <DeleteTagModal
        show={showDeleteModal}
        handleClose={(e: any) => {
          e.stopPropagation();
          setShowDeleteModal(false);
        }}
        tag={tag}
        handleDeleteTag={handleDeleteTag}
      />
      {editingTag && <TagCreator show={true} handleClose={() => setEditingTag(false)} tag={tag} />}
    </ContextMenu2>
  );
};
